/**
 * Scan and extract the client name - if any - from the provided url
 * and return the refined base URI string with the client identifier string appended
 * accordingly
 *
 * @returns string - the refined base URI including the appended client name (if any)
 */
export function refineBaseURI() {
    const clientURI = window?.location?.hostname.split('.').length > 2 ? window?.location?.hostname.split('.')[0] : null;
    let hostname = window.location.hostname;
    const urlProtocol = window.location.protocol;
    // console.log('hostname', hostname);
    if(!!clientURI) {
        hostname = hostname.replace(clientURI, `api-${clientURI}`);
    } else {
        hostname = `api.${hostname}`;
    }
    // console.log('hostname', hostname);
    // console.log('urlProtocol', urlProtocol);
    // console.log('window.location', window.location);
    // console.log('refinedAPIURI', refinedAPIURI);
    // console.log('refinedBaseURI', refinedBaseURI);
    return `${urlProtocol}//${hostname}/api/v1`;
}